namespace Solovis.Reports.DataPacks {

    export interface DataPackDetailDialogOptions {
        mountCode?: string;
        packIds?: string[];
    }

    export class DataPackDetailDialog {

        private _options: DataPackDetailDialogOptions;

        private _dialog: Solovis.UI.Dialog;

        private _gridInstance: DevExpress.ui.dxDataGrid;
        
        private _gridDataStore: DevExpress.data.ArrayStore;

        constructor(options: DataPackDetailDialogOptions) {
            this._options = options;
        }


        public async show() {
            if (this._dialog) {
                // dialog has already been shown.
                return;
            }           

            let dialogDiv = $("<div>");
                
            let gridData = new DevExpress.data.ArrayStore({
                key: 'packId',
                data: []
            });            

            let tableDiv = $("<div>").appendTo(dialogDiv);

            let dataGrid = ($(tableDiv) as any).dxDataGrid({
                dataSource: {
                    store: gridData
                },                    

                width: 550,

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,                    
                columnChooser: { enabled: true },
                columnFixing: { enabled: true },
                columnResizingMode: "widget",
                paging: { enabled: false },

                onContextMenuPreparing: (e: any) => {
                    if (e.row && e.row.rowType === "data") {
                        let entryData = e.row.data;

                        e.items = [];

                        if (entryData.allowUserRefresh) {
                            e.items.push({
                                text: "Request Reload",
                                onItemClick: () => {
                                    DataPackSelectorDialog.showRequestRefreshInterface(entryData);
                                }
                            });
                        }
                    }
                },

                columns: [
                    {
                        dataField: 'packId',
                        dataType: 'string',
                        allowSorting: true,                            
                        width: 290,
                        fixed: true
                    },
                    {
                        dataField: 'mountCode',
                        dataType: 'string',
                        allowSorting: true,
                        width: 200,
                        fixed: false,
                        visible: false
                    },
                    {
                        dataField: 'valueSource',
                        dataType: 'Value Source',
                        allowSorting: true,
                        width: 100                               
                    },
                    {
                        dataField: 'includedStr',
                        dataType: 'string',
                        caption: "Included",
                        allowSorting: true,
                        width: 600
                    },
                    {
                        dataField: 'status',
                        dataType: 'Status',
                        allowSorting: true,
                        width: 175
                    },
                    {
                        dataField: "creationStartedAt",
                        dataType: 'date',
                        caption: 'Creation Started At',
                        width: 155,
                        allowSorting: true,
                        format: "shortDateShortTime",
                        visible: true
                    },
                    {
                        dataField: "creationFinishedAt",
                        dataType: 'date',
                        caption: 'Creation Finished At',
                        width: 155,
                        allowSorting: true,
                        format: "shortDateShortTime",
                        visible: true
                    },
                    {
                        dataField: "creationTimeSeconds",
                        dataType: 'number',
                        caption: 'Creation Time (seconds)',
                        width: 200,
                        allowSorting: true,
                        format: "#,##0.000"
                    },
                    {
                        dataField: "timeToLoadSeconds",
                        dataType: 'number',
                        caption: 'Time To Load (seconds)',
                        width: 200,
                        allowSorting: true,
                        format: "#,##0.000"
                    }
                ]                    
            });

            this._gridInstance = dataGrid.dxDataGrid("instance");

            let desiredWidth = Math.min($(window).width() * 0.9, 2000);
            let desiredHeight = Math.min($(window).height() * 0.9, 600);

            let resizeDataGrid = () => {                    
                let height = this._dialog.getAvailableContentHeight();
                let width = this._dialog.getAvailableContentWidth();
                    
                this._gridInstance.option("width", width);
                this._gridInstance.option("height", height);
            };

            this._dialog = new Solovis.UI.Dialog({
                container: dialogDiv,

                title: "Data Pack Details",

                destroyOnClose: true,
                autoOpen: true,
                center: true,

                width: desiredWidth,
                height: desiredHeight,

                modal: true,

                actions: ["Close"],

                activate: function () {                       
                    resizeDataGrid();
                },

                resize: function () {
                    resizeDataGrid();
                },

                buttons: [
                    {
                        label: "Refresh",
                        click: () => {
                            this._refreshAsync();
                        }
                    },
                    {
                        label: "Close",
                        click: () => {
                            this._dialog.close();
                        }
                    }
                ]
            });           

            this._refreshAsync();
        }


        private async _refreshAsync() {
            var waitPanel = new Solovis.UI.ModalWaitPanel({});
            waitPanel.show();
            try {
                let response = await Solovis.Rpc.invoke(
                    "~/Rpc/DataSource/GetDataPackMounts",
                    { includeDetails: true });

                let mountList: any[] = response.result.byMountCode;

                let packInfoList = [];

                let packIdsFound = [];

                for (let mountEntry of mountList) {
                    if ((this._options.mountCode && mountEntry.mountCode === this._options.mountCode)
                        || (!this._options.mountCode && this._options.packIds)) {

                        if (mountEntry.mounts) {
                            for (let packInfo of mountEntry.mounts) {
                                if (!this._options.packIds || _.contains(this._options.packIds, packInfo.packId)) {
                                    packInfo.mountCode = mountEntry.mountCode;

                                    packInfoList.push(packInfo);

                                    packIdsFound.push(packInfo.packId);
                                }
                            }
                        }
                    }
                }

                if (this._options.packIds) {
                    // Add entry for every requested packId not found to indicate it wasn't found (i.e. no longer hosted in memory, so we can't provide details).
                    for (let packId of this._options.packIds) {
                        if (!_.contains(packIdsFound, packId)) {
                            packInfoList.push({
                                packId: packId,
                                notFound: true
                            });
                        }
                    }
                }

                for (let entry of packInfoList) {
                    if (Solovis.isNotNull(entry.creationFinishedAtUtcTimestamp) && Solovis.isNotNull(entry.creationStartedAtUtcTimestamp)) {
                        entry.creationTimeSeconds = (entry.creationFinishedAtUtcTimestamp - entry.creationStartedAtUtcTimestamp) / 1000;

                        entry.creationFinishedAt = new Date(entry.creationFinishedAtUtcTimestamp);
                        entry.creationStartedAt = new Date(entry.creationStartedAtUtcTimestamp);
                    }

                    if (Solovis.isNotNull(entry.timeToLoadMs)) {
                        entry.timeToLoadSeconds = entry.timeToLoadMs / 1000;
                    }

                    if (entry.notFound) {
                        entry.includedStr = "NOT FOUND";
                    }
                    else {
                        if (entry.included) {
                            entry.includedStr = entry.included.join(", ");
                        }
                    }

                    let status = "";
                    if (entry.notLoaded) {
                        status = "Not Loaded";
                    } else {
                        status = "Loaded";
                    }

                    if (entry.isLoadInProgress) {
                        status += " (Loading...)";
                    }

                    if (entry.lastLoadHadException) {
                        status += "; Last Load Failed";
                    }

                    entry.status = status;
                }
                
                let gridData = new DevExpress.data.ArrayStore({
                    key: 'packId',
                    data: packInfoList
                });


                this._gridDataStore = gridData;
                this._gridInstance.option("dataSource", this._gridDataStore);
            }
            finally {
                waitPanel.dispose();
            }
        }
    }


}